import CreateInvestmentError from './CreateInvestmentError';
class InvalidPaymentPlanStatus extends CreateInvestmentError {
    constructor(options) {
        super('Payment plan id is not approved', options);
    }
}
export default InvalidPaymentPlanStatus;
